import { render, staticRenderFns } from "./AmostrasInfo.vue?vue&type=template&id=0589d75c&"
import script from "./AmostrasInfo.vue?vue&type=script&lang=ts&"
export * from "./AmostrasInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports